import React, { useEffect, useState } from "react";
import { CreateCheckListForm, Section } from "../../types/api";
import { useFireSafetyAudits } from "../../store/store";
import { useLocation, useNavigate } from "react-router-dom";

const ViewCheckList: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { moduleName } = location.state || {};
  const currentModuleName =
    moduleName ||
    (location.pathname.includes("/hazardous-materials")
      ? "hazardous_materials"
      : location.pathname.includes(
            "/equipment-management/maintenance-scheduling-and-tracking",
          )
        ? "equipment_management"
        : "fire_system");
  const [formData, setFormData] = useState<CreateCheckListForm>({
    checkList: "",
    itemNo: undefined,
    riskRating: undefined,
    appliesToArea: "",
    auditType: "",
    checkListDescription: "",
    moduleName: "",
    isActive: true,
  });
  const [sections, setSections] = useState<Section[]>([]);
  const { currentChecklist } = useFireSafetyAudits();

  const handleCancel = () => {
    if (currentModuleName === "hazardous_materials") {
      navigate("/hazardous-materials/audits/check-list");
    } else if (currentModuleName === "equipment_management") {
      navigate(
        "/equipment-management/maintenance-scheduling-and-tracking/check-list",
      );
    } else {
      navigate("/fire-safety-audits/check-list");
    }
  };

  useEffect(() => {
    if (currentChecklist) {
      setFormData({
        checkList: currentChecklist.checkList,
        itemNo: currentChecklist.itemNo,
        riskRating: currentChecklist.riskRating,
        appliesToArea: currentChecklist.appliesToArea,
        auditType: currentChecklist.auditType,
        moduleName: "",
        checkListDescription:
          (currentChecklist as any).checkListDescription || "N/A",
        isActive: currentChecklist.isActive,
      });
      setSections((currentChecklist as any).sections || []);
    }
  }, [currentChecklist]);
  return (
    <div className="px-2 py-4 mt-14 w-full h-screen">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">
          View Audit Check List
        </h2>
      </div>
      <div className="max-w-7xl shadow-lg ">
        {/* Header Information */}
        <div className="h-screen bg-white flex flex-col">
          {/* Main Header - Fixed height */}
          <div className="flex-shrink-0  mt-4 ml-4 ">
            <div className="flex justify-between items-start mb-6">
              <div className="grid grid-cols-6 gap-8 text-sm">
                <div>
                  <span className="text-gray-600 font-medium">
                    Checklist Name
                  </span>
                  <div className="text-blue-600 font-medium">
                    {formData.checkList || "N/A"}
                  </div>
                </div>
                <div>
                  <span className="text-gray-600 font-medium">Item No</span>
                  <div className="text-blue-600 font-medium">
                    {formData.itemNo || "N/A"}
                  </div>
                </div>
                <div>
                  <span className="text-gray-600 font-medium">Risk Rating</span>
                  <div className="text-blue-600 font-medium">
                    {formData.riskRating || "N/A"}
                  </div>
                </div>

                <div>
                  <span className="text-gray-600 font-medium">
                    Applies To Area
                  </span>
                  <div className="text-blue-600 font-medium">
                    {formData.appliesToArea || "N/A"}
                  </div>
                </div>
                <div>
                  <span className="text-gray-600 font-medium">Audit Type</span>
                  <div className="text-blue-600 font-medium">
                    {formData.auditType || "N/A"}
                  </div>
                </div>
                <div>
                  <span className="text-gray-600 font-medium">Is Active</span>
                  <div className="text-blue-600 font-medium">
                    {formData.isActive ? "Active" : "Inactive"}
                  </div>
                </div>
                <div>
                  <span className="text-gray-600 font-medium">
                    CheckList item Description
                  </span>
                  <div className="text-blue-600 font-medium">
                    {formData.checkListDescription || "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 flex flex-col mx-8 mb-8 bg-white h-screen rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="h-screen overflow-y-auto">
              <div className="space-y-6">
                {sections.map((section, sectionIndex) => (
                  <div
                    key={section.id}
                    className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
                  >
                    <div className="bg-gray-200 px-6 py-3 flex justify-between items-center">
                      <div className="flex items-center gap-2">
                        <input
                          type="text"
                          value={section.title}
                          disabled={true}
                          className="text-lg font-medium text-gray-800 bg-transparent border-none outline-none flex-1 placeholder-gray-500"
                          placeholder="Enter Header"
                        />
                      </div>
                    </div>

                    {/* Questions Container */}
                    <div className="p-6 space-y-4">
                      {section.questions.map((question, questionIndex) => (
                        <div key={question.id} className="space-y-2">
                          {/* Question Label */}
                          <div className="text-gray-700 font-medium">
                            {questionIndex + 1} Question
                          </div>

                          {/* Question Input with Actions */}
                          <div className="flex items-center gap-3">
                            <input
                              type="text"
                              value={question.text}
                              disabled={true}
                              placeholder="Enter Question"
                              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Form Footer - Fixed at bottom with consistent height */}
            <div className="relative z-50 flex-shrink-0 bg-[#61748e] px-6 py-2 border-t border-gray-200 flex justify-end mt-10 gap-3">
              <button
                type="button"
                onClick={handleCancel}
                className="relative z-50 flex items-center justify-center font-semibold gap-3 bg-[#869ab6] text-white px-4 py-2 rounded-full"
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCheckList;
